import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const AndorraFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14202'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14202)'>
				<rect
					width='20'
					height='14'
					fill='#1537D1'
				/>
				<rect
					x='9.52344'
					width='10.4762'
					height='14'
					fill='#EA3058'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 14H13.3327V0H6.66602V14Z'
					fill='#FFCF3C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.04688 6.06663H9.99926V6.5333H9.04688V6.06663Z'
					fill='#FFEDB1'
				/>
				<path
					d='M8.96539 6.29489C8.94885 6.10035 9.10229 5.93331 9.29753 5.93331H10.7031C10.8984 5.93331 11.0518 6.10035 11.0353 6.29489L10.9595 7.18554C10.9172 7.68379 10.5004 8.06664 10.0003 8.06664C9.50029 8.06664 9.0835 7.68379 9.04113 7.18554L8.96539 6.29489Z'
					stroke='#D32E28'
					strokeWidth='0.666667'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.04688 6.53331H10.9516V6.99998H10.4754H9.52307H9.04688V6.53331Z'
					fill='#D32E28'
				/>
			</g>
		</svg>
	);
};

export default AndorraFlagIcon;
